(function() {
    'use strict';
    
    Utils.appHeight();

    /* Tiles Masonry*/
    $(document).ready(function() {

        var grid = $('.mod_catalogUniversalView.hecken-list').imagesLoaded(function() {
            grid.masonry({
                itemSelector: '.ctlg_teaser',
                percentPosition: true
            });
        });
    });

    /* Filter: Search by name */
    var searchContainer = $('#id_form_search_by_name').parent();
    var targetInput = $('#id_form_search_by_name');
    $(targetInput).focusin(function(){
        searchContainer.addClass('active');
    });
    $(targetInput).focusout(function(){
        if (targetInput.val() == '') {
            searchContainer.removeClass('active');
        }
    });
    $(document).ready(function() {
        if (targetInput.val()) {
            searchContainer.addClass('active');
        }
    });

    /* Filter Field Accordions */
    $('.ctlg_form_field.checkbox.accordion, .ctlg_form_field.radio.accordion').each(function() {

        $(this).on(Utils.clickEvent, () => {
            $(this).toggleClass('accordion-open');
            if ( ($(this).find('.checkbox_wrapper')) || ($(this).find('.radio_wrapper')) ) {
                $(this).find('.accordion').slideToggle(200);
            }
        });

        if ( ($(this).find('input[type="radio"]').is(':checked')) || ($(this).find('input[type="checkbox"]').is(':checked')) ) {
            $(this).find('.accordion').show();
            $(this).addClass('accordion-open');
        }
    });

    /* Stop Accordion bubble */
    $('.checkbox_container > input, .radio_container > input').each(function() {

        $(this).on(Utils.clickEvent, (e) => {
            e.stopPropagation();
        });
    });

    /* Filter Accordions */
    $('.detail-search > h6, .quick-search > h6').each(function() {

        $(this).on(Utils.clickEvent, () => {
            $(this).parent().toggleClass('filter-closed');
            $(this).parent().find('form').slideToggle(400);
        });
    });

    /**
     * Tooltips
     */
    var $allTooltips = $('.ctlg_form_field .label__tooltip');
    var $allDescr = $('.ctlg_form_field .description');

    $('.ctlg_form_field').each(function() {
        var $field = $(this);
        var $tooltip = $field.find('.label__tooltip');
        var $descr = $field.find('.description');

        if ($tooltip.length > 0 && $descr.length > 0) {
            $tooltip.on(Utils.clickEvent, function(e) {
                e.preventDefault();

                if ($tooltip.hasClass('show')) {
                    $tooltip.removeClass('show');
                    $descr.css({
                        left: -9999,
                        top: -9999
                    });
                } else {
                    $allTooltips.removeClass('show');
                    $allDescr.css({
                        left: -9999,
                        top: -9999
                    });

                    $tooltip.addClass('show');
                    $descr.show().css({
                        left: $tooltip.position().left + 105 + $tooltip.width() + 'px',
                        top: $tooltip.position().top + $tooltip.outerHeight() * 0.5 - $descr.outerHeight() * 0.35
                    });
                }

                return false;
            });

            $(document).on('click', function(e) {
                var $target = $(e.target);

                if ($target.closest('.label__tooltip').length === 0 && $target.closest('div.description').length === 0) {
                    $tooltip.removeClass('show');
                    $descr.css({
                        left: -9999,
                        top: -9999
                    });
                }
            });
        }
    });

    /**
     * Combine Quick and Detail filter forms
     */
    let $forms = $('.ce_catalogFilterForm form').not('.search-by-name');

    if ($forms.length > 0) {
        $forms.find('[onchange]').unbind('change').removeAttr('onchange').on('change', function() {
            window.location = $forms.first().attr('action') + '?' + $forms.serialize();
            return false;
        });
        $forms.on('submit', function() {
            window.location = $(this).attr('action') + '?' + $forms.serialize();
            return false;
        });
    }

    /**
     * Garden Telephone
     */
     $('.garden-telephone .element .button').click(function() {
        $(this).closest('.element').toggleClass('show');
    });
    $('.garden-telephone .element .close').click(function() {
        $(this).closest('.element').removeClass('show');
    });

})();
